// src/documents/xlsx/generateTopraklamaHesabiXlsx.js
//
// Topraklama Hesabı XLSX üreticisi — ZIP-tabanlı surgical update kullanır
// (xlsxZipUpdater). SheetJS Community write'ı border'ları kaybediyor; bu
// sebeple template'i bir ZIP olarak açıp yalnızca hücrelerin <v> değerlerini
// değiştiriyoruz, geri kalan her şey (borders/fills/merges) aynen kalır.
//
// Şablon yapısı (sayfa: "topraklama hesa"):
//   V5/V7/V9/V11/V13 : β, L, Iç, A, Es (girdiler)
//   Q19/Q23/Q27/Q31/Y27: D, Ry, Rç, Re hesapları
//   AB22/AB24/AF23/AE27: UL, EKA, Ra
//   AL27: sonuç metni  |  Y31: β kabul notu

import { loadXlsxTemplate } from './templateLoader';
import { applyCellUpdatesToXlsx } from './xlsxZipUpdater';

function round(x) { return Math.round(x * 100) / 100; }

/**
 * @param {Object} data - { soilResistivity, area, strakeLength, stripLength, ul, strakeCount }
 * @returns {Promise<ArrayBuffer>} XLSX binary
 */
export async function generateTopraklamaHesabiXlsx(data) {
  const buf = await loadXlsxTemplate('topraklamaHesabi');

  const {
    soilResistivity = 100,
    area            = 10,
    strakeLength    = 5,    // Iç (m)
    stripLength     = 20,   // L  (m)
    ul              = 50,   // V
    strakeCount     = 2,    // Es
  } = data || {};

  // Hesaplamalar (generateTopraklamaHesap.js ile aynı formül)
  const D  = 2 * Math.sqrt(area / Math.PI);
  const Ry = soilResistivity / (2 * D) + soilResistivity / stripLength;
  const Rc = soilResistivity / (strakeCount + strakeLength);
  const Re = (Ry * Rc) / (Ry + Rc);
  const eka = 0.3; // 300 mA
  const Ra  = ul / eka;
  const isOk = Re < Ra;

  const updates = {
    V5:  soilResistivity,
    V7:  stripLength,
    V9:  strakeLength,
    V11: area,
    V13: strakeCount,
    Q19: round(D),
    Q23: round(Ry),
    Q27: round(Rc),
    Q31: round(Re),
    Y27: round(Re),
    AB22: ul,
    AB24: eka,
    AF23: round(Ra),
    AE27: round(Ra),
    AL27: isOk ? 'Olduğu için uygundur...' : 'Olduğu için UYGUN DEĞİLDİR',
    Y31:  `Not: Toprak Özgül direnci tahmini olarak ${soilResistivity}  Ω  kabul edilmiştir..`,
  };

  return await applyCellUpdatesToXlsx(buf, updates);
}

export default generateTopraklamaHesabiXlsx;
